import { STORE_COMMIT } from "../store/store";

export const tableConfigMixin = {
	data() {
		return {

		};
	},

	computed: {



	},

	watch: {
		filterInput: function (filter) {
			console.log("FP: watcher: ", filter);

			/*if (!filter) {
				return;
			}*/

			if (filter && filter.length > 2) {
				this.filterChanged(filter)
			}

			if (filter == null || filter == "") {
				this.filterChanged(null)
			}
		}
	},

	methods: {


		filterChanged(filter) {

			const tableConfig = this.tableConfig
			tableConfig.filter = filter;
			tableConfig.scrollLimit = tableConfig.defaultScrollLimit

			this.$store.commit(STORE_COMMIT.UPDATE_TABLE_CONFIG, tableConfig);
			this.resetScroll()

		},

		resetScroll() {
			console.log('FP: tableConfig.resetScroll()');
			
		},





	}
}
